import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Box, Stack, Button } from '@mui/material';
import useGlobalStatus from '../../hook/useGlobalStatus';
import { ButtonMain } from "../customComponent/button";
import { ArrowBackOutlinedIcon } from "../../constants/images";


const ButtonSendData = (props) => {
  const { colorSystem, setCurrentTab, clickUpdateReport, url } = props;
  const history = useHistory();
  const { entryPath } = useGlobalStatus();

  return (
    <Stack variant='between-center'>
      <ButtonMain
        variant="contained"
        color={colorSystem}
        onClick={() => setCurrentTab(0)}
      >
        <ArrowBackOutlinedIcon sx={{ mr: 1 }} />
        <FormattedMessage id="common.title.setReport" />
      </ButtonMain>

      <Box>
        <Button
          variant="text-cancel"
          onClick={() => history.push(url)}
        >
          <FormattedMessage id="common.button.cancel" />
        </Button>

        <ButtonMain
          variant="contained"
          color={colorSystem}
          onClick={() => clickUpdateReport()}
          sx={{ display: entryPath.includes('create') ? 'inline-block' : 'none' }}
        >
          <FormattedMessage id="createData.button.createMailSettings" />
        </ButtonMain>

        <ButtonMain
          variant="contained"
          color={colorSystem}
          onClick={() => clickUpdateReport()}
          sx={{ display: entryPath.includes('edit') ? 'inline-block' : entryPath.includes('redownload') ? 'inline-block' : 'none' }}
        >
          <FormattedMessage id="createData.button.updateMailSettings" />
        </ButtonMain>
      </Box>
    </Stack>
  )
}

export default ButtonSendData;